<template>
  <v-dialog v-model="dialogOpen" persistent rounded="lg" max-width="800" class="past-due-dialog">
    <v-card>
      <div class="card-section-header">
        <div class="d-flex align-center justify-space-between flex-wrap ga-3">
          <div class="d-flex align-center ga-3">
            <v-avatar rounded="lg" color="brand-color" variant="tonal" size="40">
              <v-icon size="18" color="brand-color">mdi-alert-circle</v-icon>
            </v-avatar>
            <div>
              <h2 class="section-title">Action Required</h2>
            </div>
          </div>
        </div>
      </div>
      <v-card-text class="px-5">
        <v-empty-state :image="imageSrc" :size="250" text-width="750">
          <template #media>
            <v-img class="rounded-lg" />
          </template>
          <template #title>
            <div class="text-title-large font-weight-bold text-high-emphasis my-1">{{ title }}</div>
          </template>
          <template #text>
            <p class="text-grey-darken-2" v-html="message"></p>
            <v-spacer class="my-4" />
            <v-btn v-if="type === ACTION_TYPES.PAST_DUE" color="brand-color"
              class="font-weight-bold text-capitalize" height="42" width="200" append-icon="mdi-email-arrow-right"
              href="mailto:hi@cliqforms.com">
              {{ buttonText }}
            </v-btn>
            <v-btn v-else color="brand-color" class="font-weight-bold text-capitalize" height="42"
              :width="buttonWidth" @click="sendToPlans">
              {{ buttonText }}
            </v-btn>
            <p v-if="type !== ACTION_TYPES.PAST_DUE" class="mt-2 mb-0 text-grey-darken-2">
              This will re-activate the account and ensure continued access to all features.
            </p>
          </template>
        </v-empty-state>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ACTION_DIALOG_TYPES } from '@/shared/constants/pricing/data'

export default {
  name: 'PActionDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ACTION_DIALOG_TYPES.TRIAL_ENDED,
      validator: (value) => Object.values(ACTION_DIALOG_TYPES).includes(value)
    },
    userName: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      ACTION_TYPES: ACTION_DIALOG_TYPES
    }
  },
  computed: {
    dialogOpen: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    title() {
      const titles = {
        [ACTION_DIALOG_TYPES.ACCOUNT_EXPIRED]: 'Account Expired',
        [ACTION_DIALOG_TYPES.TRIAL_ENDED]: 'Trial Ended',
        [ACTION_DIALOG_TYPES.PAST_DUE]: 'Billing Past Due',
        [ACTION_DIALOG_TYPES.SUBSCRIPTION_PAUSED]: 'Subscription Paused'
      }
      return titles[this.type] || 'Notice'
    },
    message() {
      const name = this.userName || 'User'
      const greeting = `Welcome Back <strong class="text-brand-color">${name}</strong>.`
      const closingText = this.type === ACTION_DIALOG_TYPES.PAST_DUE
        ? 'Please contact support at <a class="font-weight-bold text-brand-color" href="mailto:hi@cliqforms.com">hi@cliqforms.com</a> to update your billing.'
        : 'To regain access to your account & its features like forms, leads, landing pages & much more, click on the button below.'

      const specificMessages = {
        [ACTION_DIALOG_TYPES.ACCOUNT_EXPIRED]: 'Your account has expired.',
        [ACTION_DIALOG_TYPES.PAST_DUE]: 'Your account is currently in a past due state because we were unable to process your last payment.',
        [ACTION_DIALOG_TYPES.TRIAL_ENDED]: 'Your trial has ended.',
        [ACTION_DIALOG_TYPES.SUBSCRIPTION_PAUSED]: 'Your subscription is paused and it\'s past the grace period. You need to restart your subscription to use our app.'
      }

      const specificMsg = specificMessages[this.type] || specificMessages[ACTION_DIALOG_TYPES.TRIAL_ENDED]
      return `${greeting} ${specificMsg} ${closingText}`
    },
    imageSrc() {
      const images = {
        [ACTION_DIALOG_TYPES.TRIAL_ENDED]: require('@/assets/images/plans/trial.jpg'),
        [ACTION_DIALOG_TYPES.ACCOUNT_EXPIRED]: require('@/assets/images/plans/expired.jpg'),
        [ACTION_DIALOG_TYPES.PAST_DUE]: require('@/assets/images/plans/bill.jpg'),
        [ACTION_DIALOG_TYPES.SUBSCRIPTION_PAUSED]: require('@/assets/images/plans/expired.jpg')
      }
      return images[this.type]
    },
    buttonText() {
      return this.type === ACTION_DIALOG_TYPES.PAST_DUE ? 'Contact Support' : 'Subscribe Now'
    },
    buttonWidth() {
      return this.type === ACTION_DIALOG_TYPES.PAST_DUE ? '350' : '150'
    }
  },
  methods: {
    sendToPlans() {
      this.$router.push({ name: 'plans.index' })
    }
  }
}
</script>
